/** "N weitere Uhrzeiten" / "Weniger Uhrzeiten" expand control (prototype `.h-more`). */
import { FC } from "react"
import { Pressable, PressableStateCallbackType, TextStyle, View, ViewStyle } from "react-native"
import Icon from "react-native-vector-icons/MaterialIcons"

import { Text } from "@/components/Text"

import { webTransition } from "./motion"
import { moreToggleLabel } from "./rescheduleSlotModel"
import { font, tokens } from "./tokens"

export interface MoreToggleProps {
  expanded: boolean
  hiddenTotal: number
  onToggle: () => void
}

type HoverState = PressableStateCallbackType & { hovered?: boolean }

export const MoreToggle: FC<MoreToggleProps> = ({ expanded, hiddenTotal, onToggle }) => (
  <View style={$row}>
    <View style={$line} />
    <Pressable
      accessibilityRole="button"
      accessibilityState={{ expanded }}
      onPress={onToggle}
      testID="more-toggle"
      style={(state) => [$button, (state as HoverState).hovered && $hover]}
    >
      <Text style={$label}>{moreToggleLabel(expanded, hiddenTotal)}</Text>
      <View style={[$chevron, expanded && $chevronUp]}>
        <Icon name="expand-more" size={18} color={tokens.ink} />
      </View>
    </Pressable>
    <View style={$line} />
  </View>
)

const $row: ViewStyle = { flexDirection: "row", alignItems: "center", gap: 12, marginTop: -4 }
const $line: ViewStyle = { flex: 1, height: 1, backgroundColor: tokens.modalBorder }
const $button: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  gap: 8,
  minHeight: 40,
  paddingLeft: 16,
  paddingRight: 14,
  borderRadius: 300,
  borderWidth: 1,
  borderColor: tokens.field,
  backgroundColor: tokens.surface,
}
const $hover: ViewStyle = { backgroundColor: tokens.mist }
const $label: TextStyle = { fontSize: 14, fontFamily: font.bold, color: tokens.ink }
const $chevron: ViewStyle = { ...webTransition("transform", 200) }
const $chevronUp: ViewStyle = { transform: [{ rotate: "180deg" }] }
